export default __webpack_public_path__ + "static/media/icon.ed472cbc.png";